module.exports = __webpack_public_path__ + "static/media/SanuL.511ea996.svg";